import { useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function OrderDetailPage() {
  const { orderId } = useParams()

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => (window.location.href = '/orders')}
          className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">訂單詳情</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">訂單編號: {orderId}</p>
        </div>
      </div>

      {/* Order detail content */}
      <div className="rounded-xl border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <p className="text-gray-500 dark:text-gray-400">訂單詳情頁面 - 開發中</p>
      </div>
    </div>
  )
}
